<template>
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7149 0.581956C12.1054 0.97248 12.1054 1.60565 11.7149 1.99617L6.00781 7.70328L0.300706 1.99617C-0.089819 1.60564 -0.089819 0.972479 0.300706 0.581955C0.69123 0.191431 1.3244 0.191431 1.71492 0.581955L6.00781 4.87485L10.3007 0.581956C10.6912 0.191431 11.3244 0.191431 11.7149 0.581956Z"
      fill="white"
    />
  </svg>
</template>
